/**
 * Волна E (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute exact path='/auth/tinkoff'>.
 * ВАЖНО: path='/auth/tinkoff' обязателен — CacheDataRoute по нему
 * запускает partnerLoginOrRegister (T-ID возврат с state/code/session_state).
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../../CacheDataRoute';
import Index from '@routes/MainPage';

export const Route = createFileRoute('/auth/tinkoff/')({
  component: () => <CacheDataRoute component={Index} path='/auth/tinkoff' />
});
